import React, {useEffect, useState} from 'react';
import {BrowserView} from "react-device-detect";
import {formatPhoneNumber, getPhoneNumber} from "../utils/utils";
import {isEmpty} from "lodash";

const FloatingContact = ({partner}) => {
    const [myClass, setMyClass] = useState("");

    const onMouseLeave = () => {
        setMyClass("")
    }

    const onMouseEnter = () => {
        setMyClass("hover")
    }

    useEffect(() => {
        const interval = setInterval(function () {
            if (!isEmpty(myClass)) {
                onMouseEnter()
            }

            setTimeout(function () {
                onMouseLeave()
            }, 1000);
        }, 2000);

        setTimeout(function () {
            clearInterval(interval);
        }, 6000);
    }, [])

    return (
        <div className="amg-floating-contacts">
            <div className={`amg-floating-contact-wrap ${myClass}`} onMouseLeave={onMouseLeave}>
                <div className={`amg-floating-icon`} onMouseEnter={onMouseEnter}>
                    <BrowserView>
                        <span className="tb-rl">Kontaktieren Sie uns </span>
                    </BrowserView>
                    <i className="bi bi-telephone-fill"></i>
                </div>
                <div className="amg-floating-link">

                    <ul className="list-group list-group-flush">
                        <ol className="border-0 m-0 p-0">
                            <li className="list-group-item">
                                <i className="b-icon fa fa-phone"></i>
                                <a href={`tel:${formatPhoneNumber(partner?.phone)}`}>{getPhoneNumber(partner?.phone)}</a>
                            </li>
                            <li className="list-group-item"><i className="b-icon fa fa-clock-o"></i>
                                <span className="">
                                    Mo. – Fr. 09:00 – 18:00 Uhr<br/>
                                    Sa. 10:00 – 14:00 Uhr<br/>
                                    So. 10:00 – 14:00 Uhr
                                </span>
                            </li>
                            <li className="list-group-item">
                                <i className="b-icon fa fa-print"></i>
                                <span>0 61 87 / 48 04 - 335</span>
                            </li>
                            <li className="list-group-item">
                                <i className="b-icon bi bi-envelope"></i>
                                <a href="/kontakt" title="kontakt">Kontaktformular</a>
                            </li>
                        </ol>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default FloatingContact;